import { render, staticRenderFns } from "./NoticeAdd.vue?vue&type=template&id=4f982c30&scoped=true"
import script from "./NoticeAdd.vue?vue&type=script&lang=ts"
export * from "./NoticeAdd.vue?vue&type=script&lang=ts"
import style0 from "./NoticeAdd.vue?vue&type=style&index=0&id=4f982c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f982c30",
  null
  
)

export default component.exports